import _has from 'lodash/has'
import _get from 'lodash/get'

import { Reducer } from 'redux'

import { WebsitesStore } from '../typings/website'
import { WebsitesAction, WebsitesConstants } from '../actions/websites'

const initialState: WebsitesStore = {
  data: {
    records: [],
    pagination: null,
  },
  hasData: false,
  fetching: false,
  fetched: false,
  error: null,
}

export const websitesReducer: Reducer = (
  state = { ...initialState },
  action: WebsitesAction
): WebsitesStore => {
  switch (action.type) {
    case WebsitesConstants.FETCH:
      return {
        ...initialState,
        fetching: true,
      }
    case WebsitesConstants.FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        hasData: _has(action, 'data.records')
          ? _get(action, 'data.records').length > 0
          : _has(action, 'data.id'),
        fetching: false,
        fetched: true,
        error: null,
      }
    case WebsitesConstants.FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error,
      }
    default:
      return state
  }
}
